import { MoreHorizontal } from 'lucide-react';

import { Button } from '@apps/web/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@apps/web/components/ui/dropdown_menu';
import { cn } from '@apps/web/lib/utils';

type OutreachDetailsOverflowMenuProps = {
    readonly onAgentInstructions: () => void;
    readonly onManageSubscribers?: () => void;
    readonly triggerClassName?: string;
    readonly triggerVariant?: 'ghost' | 'outline';
};

export function OutreachDetailsOverflowMenu({
    onAgentInstructions,
    onManageSubscribers,
    triggerClassName,
    triggerVariant = 'ghost',
}: OutreachDetailsOverflowMenuProps) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild={true}>
                <Button
                    variant={triggerVariant}
                    size="sm"
                    className={cn('h-7 w-7 p-0', triggerClassName)}
                    aria-label="Outreach actions"
                >
                    <MoreHorizontal className="h-3.5 w-3.5" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                <DropdownMenuItem onClick={onAgentInstructions}>
                    Agent Instructions
                </DropdownMenuItem>
                {onManageSubscribers ? (
                    <DropdownMenuItem onClick={onManageSubscribers}>
                        Manage subscribers
                    </DropdownMenuItem>
                ) : null}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
